import {
  DeviceDowntimeItem,
  DeviceDowntimeItemDto
} from './downtime.models';

export function mapDeviceDowntimeItem(
  dto: DeviceDowntimeItemDto
): DeviceDowntimeItem
{
  return {
    id: dto.id,
    clinicId: dto.clinicId,
    clinicName: dto.clinicName ?? null,
    clinicTimeZone: dto.clinicTimeZone ?? null,
    deviceId: dto.deviceId,
    deviceLabel: dto.deviceLabel ?? null,
    deviceTypeName: dto.deviceTypeName ?? null,
    startTime: dto.startTime,
    expectedRepairUntil: dto.expectedRepairUntil,
    actualEndTime: dto.actualEndTime,
    reason: dto.reason,
    status: dto.status,
    isOverdue: dto.isOverdue ?? false,
    overdueByMinutes: dto.overdueByMinutes ?? null,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    affectedAppointmentIds: dto.affectedAppointmentIds ?? [],
    reachabilityImpact: dto.reachabilityImpact ?? null,
    impactResolution: dto.impactResolution ?? null,
    impactItems: dto.impactItems ?? []
  };
}
